import { getToken, setToken, removeToken } from '@/utils/auth'
import router from '@/router'
import { userLogin, getAdminInfo, loginOut } from '@/api'
import { Message } from 'element-ui'

const getDefaultState = () => {
  return {
    deviceDetailData: ''
  }
}

const state = getDefaultState()

const mutations = {
  setDeviceDetailData: (state, data) => {
    state.deviceDetailData = data
  },
}

const actions = {

  setDeviceDetailDataA({ commit, state }) {
    commit('setDeviceDetailData', state)
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

